module.exports = __webpack_public_path__ + "static/media/frame-c-arrow-right-us2.4e957f41.svg";